module.exports = __webpack_public_path__ + "static/media/transfer-FAILED.d737ce79.svg";